module.exports = __webpack_public_path__ + "img/60_chand_baori.f5cb5579.jpg";